"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const storageMechanism_1 = require("../constants/storageMechanism");
const deleteExperiment_1 = __importDefault(require("../experiments/deleteExperiment"));
exports.default = (experiment, config) => {
    const todaysDate = new Date();
    if (new Date(experiment.expiry) < todaysDate) {
        deleteExperiment_1.default(experiment.goal, experiment.name, storageMechanism_1.StorageMechanism.LocalStorage);
        return false;
    }
    return true;
};
//# sourceMappingURL=getIsExperimentLive.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pizza-hut/lib-experiments/lib/utils/getIsExperimentLive.js
// module id = ++7F
// module chunks = 56